import React, {Component} from "react";
import {connect} from "react-redux";
import AutoCompleteModelTitular from '../../components/mycomponents/uielements/AutoCompleteModelTitular';

class TopbarSearch extends Component {
  state = {
  };
  gotoUserSearch = (value) => {
    const { user } = this.props;
    if (value && user) {
      this.setState({
        visible: false
      }, () => {
        if (window && window.location && window.location.pathname) {
          if (window.location.pathname === '/dashboard/charges' || window.location.pathname.includes('/dashboard/invoices/')) {
            this.props.history.push('/dashboard/invoices/'+value);
          } else {
            this.props.history.push('/dashboard/user/'+value);
          }
        }
        if (this.autocomplete && this.autocomplete.autocomplete) {
          this.autocomplete.autocomplete.deleteValue()
        }
      });
    }
  };
  saveRef = (obj, name) => {
    this[name] = obj;
  }
  render() {
    return (
      <div style={{marginLeft:15, width:350}}>
        <AutoCompleteModelTitular  onSelect={this.gotoUserSearch} ref={(e) => this.saveRef(e, 'autocomplete')}/>
      </div>
    );
  }
}

export default connect(state => ({
  ...state.App,
}))(TopbarSearch);
